import Vue from 'vue';
import store from '@/store';
import app from '@/main.js';

function fullName(user) {
    return [user.lastName, user.firstName, user.middleName].filter(it => !!it).join(' ');
}

Vue.filter('firstAddress', function(addressList) {
    return addressList && addressList[0] && addressList[0].description;
});

Vue.filter('addressList', function(addressList) {
    return addressList.length ? addressList.map('description').slice(1).join(' >>> ') : '';
});

Vue.filter('addressListNewline', function(addressList) {
    return addressList.length ? addressList.map(i => i.place.description || (extendAddress(i.place)).description) : [];
});

Vue.filter('optionsList', function(options) {
    if (!options) {
        options = [];
    }

    return options.map('optionName').join(', ');
});

Vue.filter('ellipsisInfo', function(text) {
    if (!text || text.length < 25) {
        return text || '';
    }

    return text.split('').splice(0, 22).concat(['...']).join('');
});

Vue.filter('brand', (brandId) => {
    const brand = store.state.data.brands.find(it => it.id == brandId);

    if (!brand) {
        return brandId;
    }

    return `${brand.phoneNumber} (${brand.title})`;
});

Vue.filter('percentage', (percentage) => {
    return `${(Number(percentage) * 100).toFixed(2)}%`;
});

Vue.filter('establishment', (establishmentId, currentLang = 'uk') => {
    const establishment = store.state.data.establishments.find(it => it.id == establishmentId);

    if (!establishment) {
        return establishmentId;
    }

    return establishment['name:' + currentLang];
});

Vue.filter('category', (categoryId, currentLang = 'uk') => {
    const category = store.state.establishmentsCategories.items.find(it => it.id == categoryId);

    if (!category) {
        return categoryId;
    }

    return category['name:' + currentLang];
});

Vue.filter('typesList', (types, currentLang = 'uk') => {
    const typesIds = types.map('typeId');
    const allTypes = store.state.establishmentsTypes.allItems;
    const foundTypes = typesIds.map((id) => {
        const type = allTypes.find(it => it.id == id);
        return { id, name: (type && type['name:' + currentLang]) || ''};
    });

    return foundTypes.map('name').join('\n');
});

Vue.filter('optionClass', function(optionClassId) {
    const option = store.state.data.optionClasses.find(it => it.id == optionClassId);

    return option && option.className || '';
});

Vue.filter('district', function(districtId) {
    const district = store.state.data.districts.find(it => it.id == districtId);

    return district && district.name || '';
});

Vue.filter('createDate', function(dateString) {
    return Date.create(dateString).format('{HH}:{mm}:{ss} {dd}.{MM}.{yy}');
});

Vue.filter('time', function(dateString) {
    return Date.create(dateString).format('{HH}:{mm}');
});

Vue.filter('day', (dateString) => {
    if (!dateString) {
        return '';
    }

    return Date.create(dateString).format('{yyyy}-{MM}-{dd}');
});

Vue.filter('timeAndDate', function(dateString) {
    if (!dateString) {
        return '';
    }

    return Date.create(dateString).format('{Mon} {d} {HH}:{mm}');
});

Vue.filter('fullName', (user) => {
    return fullName(user) || app.$vuetify.lang.t('$vuetify.noDataText');
});

Vue.filter('fullNameWithRole', user => {
    const params = [Vue.filter('role')(user.roleName)];
    const noData = app.$vuetify.lang.t('$vuetify.noDataText');

    if (!user.firstName && !user.lastName) {
        params.push(noData);
    } else {
        params.push(fullName(user));
    }

    return params.join(' - ');
});

Vue.filter('paymentSender', item => {
    const translationPath = '$vuetify.pages.TechnicalSupport.additionalInfo.fpBalanceHistoryTable';
    const { cashbackSystem, taxiOrderId, account, paymentId } = item;

    if (account && account.email && !paymentId) {
        return account.email;
    }

    if (taxiOrderId && !cashbackSystem) {
        return app.$vuetify.lang.t(`${translationPath}.trip`);
    }

    const translationKey = cashbackSystem ? 'cashback' : 'refill';
    return app.$vuetify.lang.t(
        `${translationPath}.${translationKey}`
    );
});

Vue.filter('fullNameForPayment', function(user) {
    return fullName(user) || app.$vuetify.lang.t('$vuetify.system');
});

Vue.filter('money', function(amount) {
    return parseFloat(amount || 0).format(2) + app.$vuetify.lang.t('$vuetify.currency');
});

Vue.filter('role', (role) => {
    if (!role) {
        return '';
    }

    return app.$vuetify.lang.t(`$vuetify.roles.${role}`);
});

Vue.filter('status', function(status) {
    if (!status) {
        return '';
    }

    return app.$vuetify.lang.t(`$vuetify.statuses.${status}`);
});

Vue.filter('courierStatus', function(order) {
    return order.isDelivery ? app.$vuetify.lang.t(`$vuetify.statuses.${order.status}`) : '';
});

Vue.filter('deliveryOrTaxiStatus', function(order) {
    return app.$vuetify.lang.t(`$vuetify.statuses.${order.isDelivery ? 'delivery.' + order.deliveryStatus : order.status}`);
});

Vue.filter('clientInfo', function(client, noDataText = false) {
    if (noDataText && !client.user.firstName && !client.user.lastName) {
        return app.$vuetify.lang.t('$vuetify.noDataText');
    }

    if (!client || !client.user) {
        return '';
    }

    return [fullName(client.user), client.user.comment].filter(it => !!it).join(' - ');
});

Vue.filter('m', function(meters) {
    return meters && (meters * 1.0).round().toString();
});

Vue.filter('km', function(meters) {
    return ((meters || 0) / 1000).toFixed(2).toString();
});

Vue.filter('totalProductPrice', function(deliveryOrderDetails) {
    return deliveryOrderDetails ? Math.round(deliveryOrderDetails.reduce((sum, i) => sum + (i.price * i.quantity), 0))  : '';
});

Vue.filter('shortCarInfo', function(car) {
    if (!car) {
        return app.$vuetify.lang.t('$vuetify.noDataText');
    }

    const year = car.year ? `[${car.year}]` : null;

    return [car.make, car.model, car.color, car.number, year].filter(it => !!it).join(' ');
});

Vue.filter('extendAddress', extendAddress);

Vue.filter('place', place => extendAddress(place).description);

function extendAddress (address = {}) {
    const props = ['street', 'houseNumber', 'name', 'district', 'city'];

    return Object.assign({
        description: props.map(it => address[it]).filter(it => !!it).unique().join(', '),
        ...address
    });
}

Vue.filter('formOptions', options => {
    if (!options || !options.length) {
        return '-';
    }

    return options.join(', ');
});

Vue.filter('paymentType', (type) => {
    if (!type) return;
    type = type.split(',');
    type = type.filter(it => !['Bonus', '#resale', 'Brand'].includes(it));
    return type.join(', ');
});

Vue.filter('noValue', value => {
    if (!value) {
        return '-';
    }

    return value;
});

Vue.filter('formatDate', function(value) {
    return new Date(value).toLocaleString().replace(/,/, '');
});
